module.exports = __webpack_public_path__ + "img/American-Credit-Equipment-Financing-Customer-Vioce-960w.13ec888.png";